import * as bootstrap from 'bootstrap'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

import Common from "./Common";

import Homepage from "./pages/Homepage";
import PageProgrammes from "./pages/PageProgrammes";
import PageMedias from "./pages/PageMedias";
import PageQuestionnaire from "./pages/PageQuestionnaire";

import SingleTopic from "./pages/SingleTopic";
import SingleProgramme from "./pages/SingleProgramme";

import "./web-components/UmButton";
import "./web-components/UmBack";
import "./web-components/UmSlider";
import "./web-components/UmQuesForm";
import "./web-components/UmQuesFormV2";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin)

window.addEventListener("load", async () => {
    let common = new Common();
    common.init();

    init()
});

const init = async () => {
    // ScrollTrigger.killAll()
    let mobiscroll_lang = mobiscroll.localeEn
    switch (lang) {
        case 'en':
        mobiscroll_lang = mobiscroll.localeEn
        break;
        case 'tc':
        mobiscroll_lang = {
            "setText":"確定",
            "cancelText":"取消",
            "clearText":"明確",
            "closeText":"關閉",
            "selectedText":"{count} 選取",
            "dateFormat":"YYYY年M月D日",
            "dateFormatLong":"YYYY年M月D日",
            "dateWheelFormat":"|M月D日 DDD|",
            "dayNames":["週日", "週一", "週二", "週三", "週四", "週五", "週六"],
            "dayNamesShort":["日", "一", "二", "三", "四", "五", "六"],
            "dayNamesMin":["日", "一", "二", "三", "四", "五", "六"],
            "fromText":"開始時間",
            "monthNames":["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
            "monthNamesShort":["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二"],
            "timeFormat":"H:mm",
            "toText":"結束時間",
            "nowText":"當前",
            "pmText":"下午",
            "amText":"上午",
            "yearSuffix":"年",
            "monthSuffix":"月",
            "daySuffix":"日",
            "todayText":"今天",
            "dateText":"日",
            "timeText":"時間",
            "allDayText":"全天",
            "noEventsText":"無事件",
            "eventText":"活動",
            "eventsText":"活動",
            "moreEventsText":"他 {count} 件",
            "weekText":"第 {count} 週",
            "rangeStartLabel":"開始時間",
            "rangeEndLabel":"結束時間",
            "rangeStartHelp":"選取",
            "rangeEndHelp":"選取",
            "filterEmptyText":"沒有結果",
            "filterPlaceholderText":"搜尋"
        }
        break;
        case 'sc':
        mobiscroll_lang = mobiscroll.localeZh
        break;

    }
    mobiscroll.setOptions({
        locale: mobiscroll_lang,
    });


    const pageProgrammesDOM = document.querySelector(".page#programme-cat-listing");
    if (pageProgrammesDOM) {
        let pageProgrammes = new PageProgrammes(pageProgrammesDOM);
        await pageProgrammes.init();
    }

    const pageMediasDOM = document.querySelector(".page#media-download");
    if (pageMediasDOM) {
        let pageMedias = new PageMedias(pageMediasDOM);
        await pageMedias.init();
    }

    const pageQuestionnaireDOM = document.querySelector(".page#questionnaire");
    if (pageQuestionnaireDOM) {
        let pageQuestionnaire = new PageQuestionnaire(pageQuestionnaireDOM);
        await pageQuestionnaire.init();
    }
    
    const singleProgrammeDOM = document.querySelector(".single#single-programme");
    if (singleProgrammeDOM) {
        let singleProgramme = new SingleProgramme(singleProgrammeDOM);
        await singleProgramme.init();
    }

};
